import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-zipcode-input',
  templateUrl: './zipcode-input.component.html',
  styles: [
    `
      input {
        width: 115px;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ZipcodeInputComponent),
      multi: true
    }
  ]
})
export class ZipcodeInputComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() disabled = false;
  @Input() maxlength: string | number | null = 100;
  @Input() borderless = false;
  @Input() allowEdit = true;
  @Input() placeholder = '';

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onKeyDown(event: any) {
    if (event.ctrlKey || event.metaKey) return;

    const key = event.which || event.keyCode || 0;
    if (
      key === 8 || // Backspace
      key === 9 || // Tab
      key === 46 || // Del
      key === 37 ||
      key === 39 || // Arraw
      (!!!event.shiftKey && key >= 47 && key <= 57) || // Number Key
      (key >= 96 && key <= 105) // NumPad
    ) {
      return;
    } else {
      event.preventDefault();
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }

  // onKeydown(event: any) {
  //   const key = `${event.key}`;
  //   if (key.length !== 1) return;

  //   const allow = key >= '0' && key <= '9';
  //   if (!allow) {
  //     event.preventDefault();
  //   }
  // }
}
